module.exports = __webpack_public_path__ + "static/media/globalcdn1-min.ad09d06c.jpg";